/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropstatecol2Inputs */

const en_dropstatecol2 = /** @type {(inputs: Dropstatecol2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State`)
};

const de_dropstatecol2 = /** @type {(inputs: Dropstatecol2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "State" |
*
* @param {Dropstatecol2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropstatecol2 = /** @type {((inputs?: Dropstatecol2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropstatecol2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropstatecol2(inputs)
	return de_dropstatecol2(inputs)
});
export { dropstatecol2 as "dropStateCol" }